import React, { useState, useRef, useEffect } from 'react';
import { Input, Form, Button } from 'semantic-ui-react';
import { ENTER_KEY_CODE, KEY_PRESS_DOWN } from './HelperMethods/enums';
import apiService from './service/apiService';
import { regexString } from './components/userManagement/lib/helper';

const inputstylefadeIn = 'inputstyle fadeInClass';
const inputstylefadeOut = 'inputstyle fadeOutClass';
const textClassNamefadeIn = 'inputText fadeInClass';
const textClassNamefadeOut = 'inputText fadeOutClass';

function VerifyEmail({
  setForgotPassword,
  handleStep,
  forgotPasswordParams,
  handleForgotPasswordParams,
  error,
  handleError,
}) {
  const [onClickState, handleChangeEffect] = useState(false);
  const [loginButtonLoading, handleLoading] = useState(false);

  const verifyEmail = async () => {
    if (!forgotPasswordParams?.email) {
      handleError((prevState) => ({ ...prevState, email: 'Email is required' }));
    } else {
      try {
        handleLoading(true);
        const res = await apiService.forgotPassword({ userName: forgotPasswordParams?.email });
        console.log('res', res);
        const { recordId } = res;
        handleForgotPasswordParams({ target: { name: 'actionId', value: recordId } });
        handleError({});
        handleStep(1);
      } catch (err) {
        console.log(err);
        handleError((prevState) => ({ ...prevState, email: err.message || err }));
      } finally {
        handleLoading(false);
      }
    }
  };

  const inputDiv = useRef();

  const handleClickOutside = (event) => {
    // IF exists the Ref of the wrapped component AND his dom children doesnt have the clicked component
    if (inputDiv.current && !inputDiv.current.contains(event.target)) {
      // A props callback for the ClikedClickedOutside
      handleChangeEffect(false);
    }
  };

  const keyPress = async (e, clickState) => {
    if (e.type === KEY_PRESS_DOWN && e.keyCode === ENTER_KEY_CODE && clickState) {
      verifyEmail();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      <div style={{ fontWeight: 'bold', fontSize: '18px', color: '#4c4c4c' }}>Confirm Username</div>
      <div ref={inputDiv} style={{ width: '350px' }}>
        <div className={onClickState ? textClassNamefadeIn : textClassNamefadeOut}>
          Enter your Username for verification
        </div>
        <Form.Field style={{ width: '100%', marginTop: '10px' }}>
          <Input
            type="email"
            name="email"
            onChange={handleForgotPasswordParams}
            className={onClickState ? inputstylefadeIn : inputstylefadeOut}
            value={forgotPasswordParams?.email ?? ''}
            onClick={() => {
              handleChangeEffect(true);
            }}
            onKeyDown={(e) => {
              keyPress(e, onClickState);
            }}
          />
        </Form.Field>
        {error?.email && <div style={{ color: 'red' }}>{error.email}</div>}
        <>
          <div style={{ marginTop: '10px' }}>
            <Button
              onClick={verifyEmail}
              loading={loginButtonLoading}
              style={{ background: '#424f62', color: 'white' }}
            >
              Verify Username
            </Button>
          </div>
          <div style={{ marginTop: '10px' }}>
            <u
              onClick={() => {
                setForgotPassword(false);
              }}
              className="p-cursor"
            >
              Back To Login
            </u>
          </div>
        </>
      </div>
    </>
  );
}

function VerifyCodeAndUpdatePassword({
  setForgotPassword,
  handleStep,
  forgotPasswordParams,
  handleForgotPasswordParams,
  error,
  handleError,
  handleChangeEffect,
  onClickState,
}) {
  const [loginButtonLoading, handleLoading] = useState(false);

  const validate = () => {
    const errObj = {};
    if (!forgotPasswordParams?.code) {
      errObj.code = 'Code is required';
    }
    if (!forgotPasswordParams.password) {
      errObj.password = 'Password is required';
    }
    if (!forgotPasswordParams.confirmPassword) {
      errObj.confirmPassword = 'Confirm password is required';
    }
    if (forgotPasswordParams.password && !regexString.test(forgotPasswordParams.password)) {
      errObj.password =
        'Password should contain 8-16 character, one special character,one capital letter, atleast one number and no whitespace';
    }
    if (
      forgotPasswordParams.confirmPassword &&
      forgotPasswordParams.confirmPassword !== forgotPasswordParams.password
    ) {
      errObj.confirmPassword = 'Password should be same as Confirm password';
    }
    if (Object.keys(errObj)?.length) {
      return { isValid: false, errObj };
    }
    return { isValid: true };
  };

  const resetPassword = async () => {
    const { isValid, errObj } = validate();
    if (!isValid) {
      handleError(errObj);
    } else {
      try {
        handleLoading(true);
        await apiService.forgotPassword({
          userName: forgotPasswordParams?.email,
          newPassword: forgotPasswordParams.password,
          code: forgotPasswordParams.code,
          actionId: forgotPasswordParams.actionId,
        });
        handleError({});
        handleStep(2);
      } catch (err) {
        console.log(err);
        handleError((prevState) => ({ ...prevState, confirmPassword: err.message || err }));
      } finally {
        handleLoading(false);
      }
    }
  };

  const inputDiv = useRef();

  const handleClickOutside = (event) => {
    // IF exists the Ref of the wrapped component AND his dom children doesnt have the clicked component
    if (inputDiv.current && !inputDiv.current.contains(event.target)) {
      // A props callback for the ClikedClickedOutside
      handleChangeEffect({ code: false, password: false, confirmPassword: false });
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      <div style={{ fontWeight: 'bold', fontSize: '18px', color: '#4c4c4c' }}>Reset Password</div>
      <div style={{ fontWeight: 'bold', fontSize: '14px', color: '#4c4c4c', margin: '15px 0' }}>
        Check your mail for code to reset the password
      </div>

      <div ref={inputDiv} style={{ width: '350px' }}>
        <div className={onClickState.code ? textClassNamefadeIn : textClassNamefadeOut} style={{ margin: '5px' }}>
          Enter Code
        </div>
        <Form.Field style={{ width: '100%' }}>
          <Input
            type="text"
            name={`${Date.now()}_code_${Date.now()}`}
            onChange={handleForgotPasswordParams}
            className={onClickState.code ? inputstylefadeIn : inputstylefadeOut}
            value={forgotPasswordParams?.code ?? ''}
            onClick={() => {
              handleChangeEffect((prevState) => ({ ...prevState, code: true }));
            }}
            autocomplete="new-password"
          />
        </Form.Field>
        {error?.code && <div style={{ color: 'red' }}>{error?.code}</div>}
        <div className={onClickState.password ? textClassNamefadeIn : textClassNamefadeOut} style={{ margin: '5px' }}>
          New Password
        </div>
        <Form.Field style={{ width: '100%' }}>
          <Input
            type="password"
            name={`${Date.now()}_newpassword_${Date.now()}`}
            onChange={handleForgotPasswordParams}
            className={onClickState.password ? inputstylefadeIn : inputstylefadeOut}
            value={forgotPasswordParams?.password ?? ''}
            onClick={() => {
              handleChangeEffect((prevState) => ({ ...prevState, password: true }));
            }}
            autocomplete="new-password"
          />
        </Form.Field>
        {error?.password && <div style={{ color: 'red' }}>{error?.password}</div>}
        <div
          className={onClickState.confirmPassword ? textClassNamefadeIn : textClassNamefadeOut}
          style={{ margin: '5px' }}
        >
          Confirm Password
        </div>
        <Form.Field style={{ width: '100%' }}>
          <Input
            type="password"
            name="confirmPassword"
            onChange={handleForgotPasswordParams}
            className={onClickState.confirmPassword ? inputstylefadeIn : inputstylefadeOut}
            value={forgotPasswordParams?.confirmPassword ?? ''}
            onClick={() => {
              handleChangeEffect((prevState) => ({ ...prevState, confirmPassword: true }));
            }}
            autocomplete="new-password"
          />
        </Form.Field>
        {error?.confirmPassword && <div style={{ color: 'red' }}>{error.confirmPassword}</div>}
      </div>
      <>
        <div style={{ marginTop: '10px' }}>
          <Button
            onClick={resetPassword}
            style={{ background: '#424f62', color: 'white' }}
            loading={loginButtonLoading}
          >
            Reset Password
          </Button>
        </div>
        <div style={{ marginTop: '10px' }}>
          <u
            onClick={() => {
              setForgotPassword(false);
            }}
            className="p-cursor"
          >
            Back To Login
          </u>
        </div>
      </>
    </>
  );
}

function LoginToPortalMessageComponent({ setForgotPassword }) {
  const proceedToLogin = () => {
    setForgotPassword(false);
  };

  return (
    <>
      <div style={{ width: '300px' }}>
        <div style={{ fontWeight: 'bold', fontSize: '18px', color: '#4c4c4c' }}>Password Reset Successful</div>
        <div style={{ fontWeight: 'bold', fontSize: '14px', color: '#4c4c4c', margin: '15px 0' }}>
          Your password reset is successful. Login again to access your portal
        </div>
        <div style={{ marginTop: '10px' }}>
          <Button onClick={proceedToLogin} style={{ background: '#424f62', color: 'white' }} on>
            Proceed To Login
          </Button>
        </div>
      </div>
    </>
  );
}

function ForgotPasswordComponent({ setForgotPassword, email = '' }) {
  const [step, handleStep] = useState(0);
  const [error, handleError] = useState({});
  const [onClickState, handleChangeEffect] = useState({ code: false, password: false, confirmPassword: false });

  const [forgotPasswordParams, handleForgotPassword] = useState({
    email,
    code: '',
    password: '',
    confirmPassword: '',
  });
  const handleForgotPasswordParams = (event) => {
    const {
      target: { value },
    } = event;
    let {
      target: { name },
    } = event;
    console.log('handleForgotPasswordParams', event);
    if (name.includes('code_')) {
      name = 'code';
    } else if (name.includes('newpassword_')) {
      name = 'password';
    }
    if (onClickState.code && name === 'code') {
      handleForgotPassword((prevState) => ({ ...prevState, code: value }));
    } else if (onClickState.password && name === 'password') {
      handleForgotPassword((prevState) => ({ ...prevState, password: value }));
    } else if (!(name === 'password' || name === 'code')) {
      handleForgotPassword((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  if (step === 0) {
    return (
      <VerifyEmail
        handleStep={handleStep}
        setForgotPassword={setForgotPassword}
        forgotPasswordParams={forgotPasswordParams}
        handleForgotPasswordParams={handleForgotPasswordParams}
        error={error}
        handleError={handleError}
      />
    );
  }
  if (step === 1) {
    return (
      <VerifyCodeAndUpdatePassword
        handleStep={handleStep}
        setForgotPassword={setForgotPassword}
        forgotPasswordParams={forgotPasswordParams}
        handleForgotPasswordParams={handleForgotPasswordParams}
        error={error}
        handleError={handleError}
        handleChangeEffect={handleChangeEffect}
        onClickState={onClickState}
      />
    );
  }
  if (step === 2) {
    return <LoginToPortalMessageComponent setForgotPassword={setForgotPassword} />;
  }
}

export default ForgotPasswordComponent;
